import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import PaymentsTable from './Components/PaymentsTable';

const PaymentsPage = () => {
  const history = useHistory();

  return (
    <div className="w-full h-full">
      <div className="pb-1">
        <PaymentsTable
          preselectedFutureVisits={history?.location?.state?.fromPayment}
        />
      </div>
    </div>
  );
};

export default PaymentsPage;
